let mutations = {
  user(state, data){
    state.user = data
    if(data)  state.sessionId = data.sessionId
    else state.sessionId = undefined
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/login/mutations.js